import api from "api";
import { apiPostHeaderOptions } from "./apiHeaderOptions";

const bulkJobId = async (data: any, type: string, jobId: string) => {
  let url = api.config.bulkJobId();
  let requestOptions = apiPostHeaderOptions();
  if(type === 'PUT'){
    url = `${api.config.bulkJobId()}/${jobId}`;
  }
  requestOptions.method = type;
  requestOptions.body = JSON.stringify(data);
  return fetch(url, requestOptions);
};

const getNifiDailyTrends = async (filters: any) => {
  const url = api.config.nifiDailyTrends(filters);
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  };
  return fetch(url, requestOptions);
};

export const bulkUploadService = {
  bulkJobId,
  getNifiDailyTrends,
};